import React from 'react';
import { Checkbox, FormLabel } from '@mui/material';

function CheckBoxWithLabel({ checked, onChange, value, fontSize, htmlFor, label, disable, id }) {
  console.log(checked, 'checked');
  return (
    <>
      <Checkbox size="small" id={id} disableRipple={false} checked={checked} onChange={onChange} disabled={disable} value={value} />
      <FormLabel
        htmlFor={htmlFor}
        sx={{
          fontSize: fontSize ? fontSize : '14px',
          marginRight: { xs: '0px', sm: '20px', md: '20px' },
          color: 'input.font',
        }}
      >
        {label}
      </FormLabel>
    </>
  );
}

export default CheckBoxWithLabel;
